import { Core } from "@faire/design-tokens";
import { Column, Row } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { Address } from "@faire/web/ui/Addresses/Display/Address";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import isEmpty from "lodash/isEmpty";
import React from "react";
import styled from "styled-components";
import { useSelectedBrandOrder } from "../hooks/useSelectedBrandOrder";
import { HorizontalLineWithColor } from "./HorizontalLineWithMargin";
import { OrderNumber } from "./OrderNumber";
import { OrderSummaryCardImages } from "./OrderSummaryCardImages";
import { SelectedIssuesBulletedListCard } from "./SelectedIssuesBulletedListCard";
import { UserInfoSummaryCard } from "./UserInfoSummaryCard";
export var OrderSummaryCard = function OrderSummaryCard() {
  var _useSelectedBrandOrde = useSelectedBrandOrder(),
    selectedBrandOrder = _useSelectedBrandOrde.selectedBrandOrder;
  var _ref = selectedBrandOrder !== null && selectedBrandOrder !== void 0 ? selectedBrandOrder : {},
    brand_name = _ref.brand_name,
    status_string = _ref.status_string,
    brand_commission_string = _ref.brand_commission_string,
    summary_string = _ref.summary_string,
    brand_order = _ref.brand_order;
  var shipTo = brand_order === null || brand_order === void 0 ? void 0 : brand_order.shipping_address;
  return /*#__PURE__*/React.createElement(OrderSummaryCardWrapper, null, !isEmpty(selectedBrandOrder) ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OrderSummaryCardSectionWrapper, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(OrderSummaryCardImages, {
    selectedBrandOrder: selectedBrandOrder
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansMedium"
  }, brand_name), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(OrderNumber, null), brand_commission_string ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansMedium"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Be4Xu3",
    defaultMessage: [{
      "type": 0,
      "value": "Comissão"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    width: "1/2x"
  }), /*#__PURE__*/React.createElement(Typography, null, brand_commission_string)))) : null, /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansMedium"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "FM8ElT",
    defaultMessage: [{
      "type": 0,
      "value": "Total"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    width: "1/2x"
  }), /*#__PURE__*/React.createElement(Typography, null, summary_string)), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansMedium"
  }, status_string)), /*#__PURE__*/React.createElement(HorizontalLineWithColor, null), /*#__PURE__*/React.createElement(OrderSummaryCardSectionWrapper, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansMedium"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "07ErlJ",
    defaultMessage: [{
      "type": 0,
      "value": "Enviar para"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Address, {
    boldFirst: false,
    address: shipTo
  })))) : ( /*#__PURE__*/React.createElement(OrderSummaryCardSectionWrapper, null, /*#__PURE__*/React.createElement(UserInfoSummaryCard, null))), /*#__PURE__*/React.createElement(HorizontalLineWithColor, null), /*#__PURE__*/React.createElement(OrderSummaryCardSectionWrapper, null, /*#__PURE__*/React.createElement(SelectedIssuesBulletedListCard, null)));
};
var OrderSummaryCardWrapper = styled(Column).withConfig({
  displayName: "OrderSummaryCard__OrderSummaryCardWrapper"
})(["margin-top:", ";background-color:", ";min-width:320px;max-width:400px;height:fit-content;overflow-x:hidden;position:sticky;position:-webkit-sticky;top:0;"], getSpacing("5x"), Core.surface.muted);
var OrderSummaryCardSectionWrapper = styled(Column).withConfig({
  displayName: "OrderSummaryCard__OrderSummaryCardSectionWrapper"
})(["padding:", ";}"], getSpacing("3x", "2x"));